import { render } from "./Spinner.vue?vue&type=template&id=4aacc4a1&scoped=true"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=4aacc4a1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4aacc4a1"

export default script